import d4k from 'src/cards/d4k.json';
import starter from 'src/cards/starter.json';
import alleluia from 'src/cards/alleluia.json';
import stardust from 'src/cards/stardust.json';
import ekklesia from 'src/cards/ekklesia.json';
import treasure from 'src/cards/treasure.json';
import merrisia from 'src/cards/merrisia.json';

const getCardPackCode = (pack) => {
  if (pack === "D4K") return 1;
  if (pack === "Starter") return 2;
  if (pack === "Alleluia") return 3;
  if (pack === "Stardust") return 4;
  if (pack === "Ekklesia") return 5;
  if (pack === "Treasure") return 6;
  if (pack === "Merrisia") return 7;
}

const getCardPackFromCode = (code) => {
  if (code === "1") return "D4K";
  if (code === "2") return "Starter";
  if (code === "3") return "Alleluia";
  if (code === "4") return "Stardust";
  if (code === "5") return "Ekklesia";
  if (code === "6") return "Treasure";
  if (code === "7") return "Merrisia";
}

const convertDeckToLink = (deck) => {
  let link = window.location.protocol + "//" + window.location.host + "/share-deck?data=";
  deck.forEach(card => {
    link += getCardPackCode(card.pack)+","+card.id+","+card.qty+":";
  });
  return link;
}

const convertDeckToLink2 = (deck) => {
  let link = window.location.protocol + "//" + window.location.host + "/share-deck2?data=";
  deck.forEach(card => {
    link += getCardPackCode(card.pack)+","+card.id+","+card.qty+":";
  });
  return link;
}

const convertDeckToLink2open = (deck) => {
  let link = "/share-deck2?data=";
  deck.forEach(card => {
    link += getCardPackCode(card.pack)+","+card.id+","+card.qty+":";
  });
  return link;
}

const convertDataToDeck = (data) => {
  let result = [];
  let allCards = [].concat(d4k, starter, stardust, ekklesia, treasure,merrisia, alleluia);
  data.split(":").forEach(d => {
    let ds = d.split(",");
    let pack = getCardPackFromCode(ds[0]);
    let id = ds[1];
    let qty = ds[2];
    let cardFound = allCards.find(c => c.pack === pack && c.id === id);
    if (cardFound){
      cardFound.qty = parseInt(qty);
      result.push(cardFound);
    }
  });
  return result;
}

const DeckManager = {
  getCardPackCode: () => getCardPackCode(),
  getCardsInDeck: () => {
    return JSON.parse(localStorage.getItem("deck")) || [];
  },
  getNumberOfCardInDeck: (card) => {
    let storedDeck = JSON.parse(localStorage.getItem("deck")) || [];
    let existingCard = storedDeck.find(c => c.pack === card.pack && c.id === card.id);
    if (existingCard){
      return existingCard.qty;
    }
    return 0;
  },
  addCardToDeck: (card, qty) => {
    let storedDeck = JSON.parse(localStorage.getItem("deck")) || [];
    let existingCard = storedDeck.find(c => c.pack === card.pack && c.id === card.id);
    if (existingCard){
      if (existingCard.qty === 0 && qty === -1){
        return false;
      }
      existingCard.qty += qty;
      localStorage.setItem("deck", JSON.stringify(storedDeck.filter(c => c.qty > 0)));
      return true;
    }
    else {
      if (qty === 1){
        storedDeck.push({...card, "qty": qty});
        localStorage.setItem("deck", JSON.stringify(storedDeck));
        return true;
      }
    }
    return false;
  },
  export: () => {
    let deck = JSON.parse(localStorage.getItem("deck")) || [];
    return convertDeckToLink(deck);
  },export2: () => {
    let deck = JSON.parse(localStorage.getItem("deck")) || [];
    return convertDeckToLink2(deck);
  },export2open: () => {
    let deck = JSON.parse(localStorage.getItem("deck")) || [];
    return convertDeckToLink2open(deck);
  },
  import: (data) => {
    return convertDataToDeck(data);
  }
}

export default DeckManager;